export const aciMusic = {
    iconName: 'music',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: [
            {
                attr: {
                    d: 'M3 18a3 3 0 106 0 3 3 0 00-6 0zM15 14.398a3 3 0 106 0 3 3 0 00-6 0z',
                    stroke: 'currentColor',
                    'stroke-width': '.903',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M9 18V7.775a2.4 2.4 0 011.64-2.277l8.839-2.455a1.2 1.2 0 011.52 1.157v10.2M9 9.373l12-3.6',
                    stroke: 'currentColor',
                    'stroke-width': '.903',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
        ],
    },
};
